import { render, staticRenderFns } from "./DammannFreres.vue?vue&type=template&id=3f966272&scoped=true"
import script from "./DammannFreres.vue?vue&type=script&lang=js"
export * from "./DammannFreres.vue?vue&type=script&lang=js"
import style0 from "./DammannFreres.vue?vue&type=style&index=0&id=3f966272&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f966272",
  null
  
)

export default component.exports